export const DEFAULT_TARGETS = {
  'video': 'mp4',
  'image': 'jpg',
  'document': 'pdf',
  'audio': 'mp3',
  'vector': 'svg',
  'ebook': 'epub',
  'archive': 'zip',
}

export const SECONDARY_DEFAULT_TARGETS = {
  'video': 'mov',
  'image': 'png',
  'document': 'doc',
  'audio': 'wav',
  'vector': 'svg',
  'ebook': 'pdf',
  'archive': 'rar',
}